import { useBoolean } from '@dreryk/react-common';
import { ActionBar, ButtonVariant, FormLeavingEventInterceptor } from '@dreryk/react-components';

import { onlinePaymentsIntegrationTranslationKeys } from '../../translations';

import { OnlinePaymentsIntegrationForm } from './OnlinePaymentsIntegrationForm';
import { OnlinePaymentsIntegrationIntro } from './OnlinePaymentsIntegrationIntro';
import { OnlinePaymentsConfigurationCreateAction } from './OnlinePaymentsIntegrationForm.actions';

export const OnlinePaymentsIntegration = (): JSX.Element => {
   const [{ setTrue, setFalse }, integrationFormDisplayed] = useBoolean(false);

   if (!integrationFormDisplayed) {
      return <OnlinePaymentsIntegrationIntro onShowIntegrationForm={setTrue} />;
   }

   return (
      <ActionBar testId={'onlinePaymentsIntegration'} id={'onlinePaymentsIntegration'}>
         <OnlinePaymentsIntegrationForm>
            {({ handleSubmit, formState }) => (
               <>
                  <FormLeavingEventInterceptor testId={'cancelIntegration'} active={formState.isDirty}>
                     <ActionBar.PrimaryLink
                        testId={'cancel'}
                        label={onlinePaymentsIntegrationTranslationKeys.actions.cancel}
                        onClick={setFalse}
                     />
                  </FormLeavingEventInterceptor>
                  <OnlinePaymentsConfigurationCreateAction handleSubmit={handleSubmit}>
                     {({ createConfiguration }) => (
                        <ActionBar.PrimaryButton
                           testId={'createConfiguration'}
                           label={onlinePaymentsIntegrationTranslationKeys.actions.createConfiguration.buttonLabel}
                           onClick={createConfiguration}
                           variant={ButtonVariant.PRIMARY}
                           blockingOperation
                        />
                     )}
                  </OnlinePaymentsConfigurationCreateAction>
               </>
            )}
         </OnlinePaymentsIntegrationForm>
      </ActionBar>
   );
};
